import './Footer.scss'
import logo from "../../../assets/images/logo_white.png";
import {ENUMS} from "../../../enums/enums";
import AtmLink from "../../atoms/atmLink/AtmLink";
import {useTranslation} from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className={'mdl-footer'}>
      <div className={'mdl-footer-container font-small'}>
        <AtmLink noStyle to={'/'} className={'mdl-footer__logo'}>
          <img src={logo} alt={'logo'}/>
        </AtmLink>

        <div className={'mdl-footer__links'}>
          <div className={'mdl-footer__navigation'}>
            <AtmLink noStyle to={ENUMS.ROUTE_ABOUT_US}>{t("aboutUs")}</AtmLink>
            <AtmLink noStyle to={ENUMS.ROUTE_SERVICES}>{t("services")}</AtmLink>
            <AtmLink noStyle to={ENUMS.ROUTE_OUR_PEOPLE}>{t("ourPeople")}</AtmLink>
            <AtmLink noStyle to={ENUMS.ROUTE_PROJECTS}>{t("projects")}</AtmLink>
            <AtmLink noStyle to={ENUMS.ROUTE_CAREERS}>{t("careers")}</AtmLink>
            <AtmLink noStyle to={ENUMS.ROUTE_CONTACT}>{t("contact")}</AtmLink>
          </div>
          <div className={'mdl-footer__social-media'}>
            <a href={'https://www.linkedin.com/company/georgi-dimitrov-attorneys/'} target={'_blank'} rel={'noreferrer'}>LinkedIn</a>
          </div>
          <address className={'mdl-footer__contact'}>
            <span className={'text-caps'}>{t("contact")}</span><br/>
            {t("addressLine1")}<br/>
            {t("addressLine2")}<br/>
            {t("addressLine3")}<br/>
            +389 2 3230 789<br/>
            info@dimitrov.com.mk<br/>
          </address>
        </div>
      </div>
    </footer>
  )
}

export default Footer;